<template>
  <div class="t1">
    <nav_list></nav_list>
    <div v-if="info.id > 0" class="v3_body">

      <navv :title="info.strs.title" :en="info.en_tit">
      </navv>
      <div class="cont" v-html="info.strs.con">

      </div>



        <div class="wl2">
          <div class="titz" v-for="(tm, j ) in list" :key="j" @click="jump2('/page?id='+tm.id)"
            v-bind:class="{ act: tm.id == info.id}">
            {{tm.strs.title}}
          </div>


        </div>



    </div>



  </div>
</template>

<script>


import nav_list from '../index/nav_list.vue';
export default {
  name: "bus_list",

  components: {
    nav_list,
  },

  data() {
    return {
      a: 'bus_list',
      tit: [],
      list: [],
      info: {
        id: 0,
      },
      id: 1,
      txt: '',
      activeName: 0
    };
  },
  mounted(e) {
    if (!this.$route.query.id) {
      return this.jump('/')
    }
    this.id = this.$route.query.id
    this.f5()
  },

  methods: {

    f5() {
      this.get("/index/page", { id: this.id },).then((e) => {


        this.info = e.info
        this.list = e.list

      });
    },

  }
}
</script>

<style scoped>
.act {
  color: #1c5098 !important;
  font-weight: bold;
}

.titz {
  font-size: 14px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #555;
  background: #fff;
  border-radius: 8px;
  text-align: center;
  padding: 12px 24px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.titz:hover {
  background: #f5f7fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.cont {
  margin: auto;
  padding: 30px;
  overflow: hidden;
  width: 65vw;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  line-height: 1.6;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #333;
}

.wl2 {
  flex: 0 0 18%;
  padding: 15px;
  text-align: center;
  position: fixed;
  z-index: 2;
  left: 80vw;
  top: 160px;
  background: rgba(255,255,255,0.9);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

</style>



// WEBPACK FOOTER //
// src/pages/note/page.vue